import React, { useEffect } from 'react'
import useLogin from '../../../hooks/useLogin'
import styles from './AuthButtons.module.css'

const AuthButtons = ({ handleSendMessage }) => {
	const { authState, setAuthState, url, onLogin } = useLogin()

	useEffect(() => {
		if (authState && authState.accessToken) {
			handleSendMessage('Я авторизовался')
		}
	}, [authState])

	return (
		<>
			{!authState && (
				<>
					<div>Войти через</div>
					<button
						className={`${styles.authButton} ${styles.telegramButton}`}
						onClick={() => onLogin('telegram')}
					>
						Telegram
					</button>
					<button
						className={`${styles.authButton} ${styles.whatsappButton}`}
						onClick={() => onLogin('whatsapp')}
					>
						WhatsApp
					</button>
				</>
			)}
			{authState && !authState.accessToken && (
				<>
					<a
						href={url}
						target='_blank'
						className={`${styles.authButton} ${styles.whatsappButton}`}
					>
						Продолжить вход...
					</a>
					<button
						className={`${styles.authButton} ${styles.cancelButton}`}
						onClick={() => setAuthState(null)}
					>
						Отменить вход
					</button>
				</>
			)}
		</>
	)
}

export default AuthButtons
